import { useEffect, useRef, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Label, UncontrolledTooltip } from 'reactstrap'
import styles from './SelectCountry.module.css'

const PhoneWithDropDown = (props) => {
    const { id, label, formik, defaultValue, isRequired = false, permission } = props

    // add more countries if needed
    const availableCountryCodes = ['hr', 'si', 'rs', 'ba', 'me', 'xk', 'gb', 'de', 'ch']

    const phoneInputRef = useRef(null)

    const [mask, setMask] = useState('')
    const [isFocus, setIsFocus] = useState(false)

    useEffect(() => {
        defaultValue?.startsWith('+385 1') || defaultValue?.startsWith('3851') ? setMask('. ... ....') : setMask('.. ... ....')
    }, [defaultValue])

    useEffect(() => {
        isFocus && phoneInputRef?.current.numberInputRef.focus()
    }, [isFocus, mask])

    const handlePhoneChange = (value, data) => {
        // if agent deletes phone number,
        // remove also dialCode so not to break formatInternational validation
        const validValue = value === data.dialCode ? null : `+${value}`
        formik.setFieldValue(`${id}`, validValue)
    }

    return (
        <>
            <Label htmlFor={id}>{label}</Label>
            {isRequired && <span className="required-mark">*</span>}
            {permission && (
                <>
                    {' '}
                    <span id={`agentPermissionsTooltip${permission.id}`}>
                        <i className="mdi mdi-help-circle-outline"></i>{' '}
                    </span>
                    <UncontrolledTooltip pement="right" target={`agentPermissionsTooltip${permission.id}`}>
                        {permission.description}
                    </UncontrolledTooltip>
                </>
            )}
            <PhoneInput
                inputProps={{
                    id,
                }}
                ref={phoneInputRef}
                key={JSON.stringify(mask)}
                className={styles.phoneInput}
                onBlur={() => setIsFocus(false)}
                onFocus={() => setIsFocus(true)}
                country={'hr'}
                onlyCountries={availableCountryCodes}
                countryCodeEditable={false}
                value={defaultValue}
                onChange={handlePhoneChange}
                masks={{ hr: mask }}
            />
        </>
    )
}

export default PhoneWithDropDown
